import * as dayjs from 'dayjs';
import { environment } from 'src/environments/environment';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { CmsService } from './cms.service';
import { SliderService } from './slider.service';

const KEY_UPDATED_AT = 'updated_at';
const KEY_DATA_LANGUAGE = 'language_';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly http = inject(HttpClient);
  private readonly translate = inject(TranslateService);
  private readonly cmsService = inject(CmsService);
  private readonly sliderService = inject(SliderService);
  private router = inject(Router);

  public readonly languages = [
    { icon: 'us', lang: 'en', name: 'English' },
    { icon: 'cn', lang: 'cn', name: '简体中文' }
  ];

  public currentLanguage: { icon: string; name: string; lang: string } | undefined = {
    icon: '',
    name: '',
    lang: ''
  };

  onSetLanguage(lang: string) {
    // @ts-ignore
    if (window?.changeLanguage) {
      // @ts-ignore
      window?.changeLanguage?.postMessage(lang);
    }
    // @ts-ignore
    if (window?.flutter_inappwebview) {
      // @ts-ignore
      window?.flutter_inappwebview?.callHandler('changeLanguage', lang);
    }
    localStorage.setItem('lang', lang);
    this.translate.use(lang);

    this.onSetTranslationWithCache(lang);
    this.onCheckEnvironment(lang);
    this.onUpdateCurrentLang(lang);
    if (this.router.url.includes('/dashboard')) {
      this.cmsService.getCms('general_notice');
      this.sliderService.getSlider();
    }

    if (this.router.url.includes('/auth/login')) {
      this.cmsService.getCms('login_notice');
    }

    if (this.router.url.includes('/auth/sign-up')) {
      this.cmsService.getCms('registration_notice');
    }
  }

  private onUpdateCurrentLang(lang: string): void {
    this.currentLanguage = this.languages.find(language => language.lang === lang);
  }

  private onSetTranslationWithCache(lang: string): void {
    const data: any = localStorage.getItem(`${KEY_DATA_LANGUAGE}${lang}`);
    if (data && data?.length) {
      this.translate.setTranslation(lang, JSON.parse(data));
    } else {
      this.onGetLanguageLocal(lang);
    }
  }

  private onCheckEnvironment(lang: string): void {
    if (window.location.hostname === 'localhost') {
      this.onGetLanguageLocal(lang);
    } else {
      this.http.get('misc/lang').subscribe((response: any) => {
        this.onCheckUpdateLanguage(lang, response);
      });
    }
  }

  private onGetLanguageLocal(lang: string): void {
    const url = `${window.location.origin}${environment.baseHref}/assets/i18n/${lang}.json`;
    this.onUpdateCacheLanguage(url, lang);
  }

  private onCheckUpdateLanguage(lang: string, response: { updated_at: string; url: any }): void {
    const languages = Object.keys(response.url);
    const updatedAt = localStorage.getItem(KEY_UPDATED_AT);
    const data = localStorage.getItem(`${KEY_DATA_LANGUAGE}${lang}`);
    if (
      !updatedAt ||
      (updatedAt &&
        dayjs(updatedAt).format('YYYY-MM-DD HH:mm') !==
          dayjs(response.updated_at).format('YYYY-MM-DD HH:mm')) ||
      !data
    ) {
      localStorage.setItem(KEY_UPDATED_AT, response.updated_at);
      languages.forEach((language: string) =>
        this.onUpdateCacheLanguage(response.url[language], language, language === lang)
      );
    }
  }

  private onUpdateCacheLanguage(url: string, lang: string, isAlwaysUpdate: boolean = true): void {
    this.http
      .get(url, { params: { staticFile: true, t: dayjs().format('YYYYMMDDHHmmss') } })
      .subscribe(res => {
        const data: any = localStorage.getItem(`${KEY_DATA_LANGUAGE}${lang}`);
        if (!data || isAlwaysUpdate) {
          this.translate.setTranslation(lang, res);
        }

        localStorage.setItem(`${KEY_DATA_LANGUAGE}${lang}`, JSON.stringify(res));
      });
  }
}
